import { Component, Input } from '@angular/core';

@Component({
    selector: 'cart-properties',
    templateUrl: './cart.properties.component.html',
    styleUrls: []
})
export class CartPropertiesComponent {
    @Input() extraFields;

    public prepareExtraFields() {
        return Object.keys(this.extraFields).map(slug => this.extraFields[slug]);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/cart/properties/cart.properties.component.ts